import { render, staticRenderFns } from "./purchase-amount-form.vue?vue&type=template&id=72134cad&scoped=true&"
import script from "./purchase-amount-form.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-form.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-form.vue?vue&type=style&index=0&id=72134cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72134cad",
  null
  
)

export default component.exports